<template>
  <div v-show="isShow" class="footer">
    <p style="padding-top: 40px">
      点击下载三文在线教育<a style="color: #fff" @click="download()"
        >《用户服务协议》</a
      >
    </p>
    <p>
      Copyright © 2025 湖南三文在线教育科技集团有限公司 版权所有 All rights
      reserved
    </p>
    <a style="color: #fff" @click="goPath()">备案号：湘ICP备19015249号-3</a>
    <p>增值电信业务经验许可证：湘B2-20210159</p>
  </div>
</template>

<script>
export default {
  name: "stu-footer",
  props: {
    // msg: String,
  },
  data() {
    return {
      isShow: true,
      msg: "九斗是专业提升的在线学习平台。",
      pMsg: "Copyright ©湖南三文在线教育科技集团有限公司 版权所有 All rights reserved",
      alink: "湘ICP备19015249号-4",
    };
  },
  mounted() {},
  methods: {
    goPath() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index", "_blank");
    },
    download() {
      let a = document.createElement("a");
      a.href = "/static/三文在线教育用户服务协议.docx";
      a.download = "三文在线教育用户服务协议.docx";
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.footer {
  width: 100%;
  height: 280px;
  background-color: #273c62;
  color: #7aa3bf;
  a {
    cursor: pointer;
  }
  .footer-content {
    width: 100%;
    height: 280px;
    background-color: #414141;
    display: flex;
    align-items: center;
    .footer-msg {
      width: 1420px;
      margin: 0 auto;
      height: 200px;
      .footer-logo {
        // visibility: hidden;
      }
      span {
        color: #ffffff;
        font-family: FZLTXHK--GBK1-0;
        font-size: 18px;
        margin-left: 20px;
      }
      p {
        margin-top: 30px;
        color: #999;
        margin-left: 20px;
      }
    }
  }
}
</style>
